var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrbanNapsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill-rule:evenodd;}.cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:none;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2633.32,
    y1: 6181.97,
    x2: 2633.32,
    y2: 6167.77,
    gradientTransform: "matrix(27.17, 0, 0, -27.17, -71062.18, 168295.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0097dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#007cc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#006cb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066b3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.44,693H499.78L885.7,307H105.44V693"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M568.48,384.2H491.42l.26,181.25-67.1-181.31H358L300.76,535.56c-6.09-38.53-45.92-51.82-77.26-61.78-20.7-6.65-42.67-16.43-42.45-27.23.18-8.87,11.76-17.1,34.77-15.87,15.44.83,29.08,2.07,56.21,15.18l26.67-46.49c-24.73-12.59-58.94-20.54-87-20.57h-.17c-32.71,0-59.94,10.59-76.82,28.05a64.69,64.69,0,0,0-18.37,44.8c-.43,23.57,8.2,40.28,26.35,53.63,15.34,11.24,35,18.53,52.24,23.88,21.32,6.61,38.73,12.36,38.51,24.59a18.08,18.08,0,0,1-5.06,12c-5.31,5.49-13.46,7.55-24.74,7.77-21.76.46-37.89-3-63.59-18.15l-23.73,47.09c25.67,14.6,52.92,21.92,83.89,21.92l7,0c26.95-.49,48.82-7,66.2-20.93,1-.79,1.89-1.6,2.82-2.42l-2.92,15,65-.2L350,585.93a133.11,133.11,0,0,0,81.05.36l8.13,29.51,116.66.11.28-68.09H580.9c60,0,95.47-30.54,95.47-81.74C676.35,409,641.87,384.2,568.48,384.2ZM391,539.13a69.52,69.52,0,0,1-24.6-4.31L390.71,458h.47l23.93,77A72.17,72.17,0,0,1,391,539.13ZM573,495H556.06V433.1H573c22.56,0,40.57,7.51,40.57,30.55,0,23.84-18,31.35-40.57,31.35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.44,307H894.56V693H105.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrbanNapsLogo);
export default __webpack_public_path__ + "static/media/urban_naps_logo.82c44b9059c2dedd6864cea5b2cd21fc.svg";
export { ForwardRef as ReactComponent };